export enum MediaCategoryTypeEnum {
  Draft = 0,
  Sketch = 1,
  SizeSpecs = 2,
  OuterLabelPositions = 3,
  StillLife = 4,
  Dressed = 5,
  Rendering = 6,
}
